<template>
    <div class="container">
        <div class="card">
            <div class="card-body p-2">
                <div class="d-flex">
                    <div class="mr-2 flex-fill">
                        <input v-model.trim="keyword"  type="text" class="form-control" maxlength="100" spellcheck=false placeholder="グループ名 / 名前 / User名"></input>
                    </div>
                </div>
            </div>
        </div>

        <div v-show="keyword" class="list" :style="{height:wrapperHeight + 'px'}">
            <div class="wrapper" ref="wrapper">
                <div class="card">
                    <ul class="list-group list-group-flush border-bottom-0">
                        <li class="list-group-item px-2 pb-1 pt-3" v-for="item in getWorkStatusSelected" :key="item.id">
                            <work-row :item="item"></work-row>
                        </li>
                        <li v-show="hasNoSearchData" class="list-group-item text-center text-muted">該当するデータがありません</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import WorkRow from './WorkRow'
    import BScroll from 'better-scroll'
    import {mapGetters} from 'vuex'

    export default {
        components: {
            WorkRow
        },
        data () {
            return {
                keyword: '',
                time: null,
                wrapperHeight: $(window).height() - 167,
            }
        },
        mounted () {
            this.scroll = new BScroll(this.$refs.wrapper, {click:true})
        },
        watch: {
            keyword () {
                if (!this.keyword) {
                    this.resetWorkStatusSelected()
                    this.$parent.showWorkList()
                    return
                }

                this.$parent.hideWorkList()

                if (this.timer) {
                    clearTimeout(this.timer)
                }

                this.timer = setTimeout(()=> {
                    let result = []
                    result = this.getWorkStatus.data.filter((item)=>
                        item.user_group.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1 
                        || (item.first_nm + item.last_nm).indexOf(this.keyword) != -1
                        || (item.first_kana + item.last_kana).indexOf(this.keyword) != -1
                        || item.name.toLowerCase().indexOf(this.keyword.toLowerCase()) != -1
                    )
                    this.setWorkStatusSelected(result)

                }, 100)
            }
        },
        computed: {
            hasNoSearchData () {
                return !this.getWorkStatusSelected.length
            },
            ...mapGetters(['getWorkStatus', 'getWorkStatusSelected'])
        },
        methods: {
            setWorkStatusSelected (list) {
                this.$store.dispatch('setWorkStatusSelected', list)
            },
            resetWorkStatusSelected () {
                this.$store.dispatch('resetWorkStatusSelected')
            },
        }
    }
</script>

<style lang="stylus" scoped>
    .list
        position: relative
        .wrapper
            overflow: hidden
            position: absolute
            top: 0.5rem
            left: 0
            right: 0
            bottom: 0
</style>
